<template>
  <div class="container">
    <div class="max-w-xl">
      <BaseInput v-model="state.product.title" label="Produktnamn" />
      <div class="mt-3 ">
        <span
          class="block mb-1 text-gray-900 tracking-wide text-sm font-semibold"
        >
          Leverantör
        </span>
        <select
          name=""
          id=""
          v-model="state.product.supplier"
          class="form-control"
        >
          <option :value="null">Ingen Leverantör</option>
          <option
            v-for="supplier of suppliers"
            :value="supplier.id"
            :key="supplier.id"
            >{{ supplier.name }}</option
          >
        </select>
      </div>
      <div class="mt-3">
        <span
          class="block mb-1 text-gray-900 tracking-wide text-sm font-semibold"
        >
          Varumärke
        </span>
        <select
          name=""
          id=""
          v-model="state.product.brand"
          class="form-control"
          :disabled="!state.product.supplier"
        >
          <option :value="null">Inget varumärke</option>
          <option v-for="brand of brands" :value="brand.id" :key="brand.id">{{
            brand.title
          }}</option>
        </select>
      </div>
      <!-- <BaseInput
        v-if="state.product.supplier"
        disabled
        v-model="state.product.supplier.name"
        label="Leverantör"
        class="mt-3"
      />
      <BaseInput
        v-if="state.product.brand"
        disabled
        v-model="state.product.brand.title"
        label="Märke"
        class="mt-3"
      /> -->
      <BaseInput v-model="state.product.series" label="Serie" class="mt-3" />
      <BaseTextarea
        v-model="state.product.description"
        label="Beskrivning"
        rows="7"
        class="mt-3"
      />
      <BaseInput
        v-model="state.product.barcode"
        label="Streckkod"
        class="mt-3"
      />
      <BaseInput
        v-model="state.product.barcodetwo"
        label="Streckkod 2"
        class="mt-3"
      />
      <div class="flex mt-3">
        <BaseInput
          v-model="state.product.weight"
          label="Vikt (gram)"
          unit="g"
        />
        <BaseInput
          v-model="state.product.size"
          label="Storlek (ml)"
          unit="ml"
        />
      </div>
      <div class="flex mt-3">
        <BaseInput
          v-model.number="state.product.recommendedConsumerPrice"
          label="Rek utpris"
          unit="kr"
          type="number"
        />
        <BaseInput
          v-model.number="state.product.recommendedSaloonPrice"
          label="Inpris"
          unit="kr"
          type="number"
        />
      </div>

      <button @click="save" class="btn btn-secondary mt-4">
        Spara
      </button>
    </div>
  </div>
</template>

<script>
import { reactive, watch } from '@vue/composition-api'
import CreateProduct from '@/graphql/CreateProduct.gql'
import { useSuppliers } from '@/composables/use-suppliers'
import { useBrands } from '@/composables/use-brands'
import gql from 'graphql-tag'
export default {
  setup(props, { root }) {
    const state = reactive({
      product: {
        supplier: null,
        brand: null,
      },
    })

    const { suppliers } = useSuppliers()
    const { brands } = useBrands()

    const save = async () => {
      await root.$apollo.mutate({
        mutation: CreateProduct,
        variables: {
          data: {
            title: state.product.title,
            barcode: state.product.barcode,
            barcodetwo: state.product.barcodetwo,
            size: state.product.size,
            weight: state.product.weight,
            series: state.product.series,
            description: state.product.description,
            recommendedSaloonPrice: state.product.recommendedSaloonPrice,
            recommendedConsumerPrice: state.product.recommendedConsumerPrice,
            brandId: state.product.brand,
          },
          id: root.$route.params.id,
        },
      })
      root.$router.push({ name: 'products' })
    }

    return { state, save, suppliers, brands }
  },
}
</script>

<style lang="scss" scoped></style>
